export const API_URL = process.env.API_URL
export const AUTH_TOKEN = process.env.AUTH_TOKEN
